module.exports = __webpack_public_path__ + "static/img/xxgk.8303656.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/xxgk.webp
// module id = hQf1
// module chunks = 68